//react
import React, { Component } from 'react';
import PropTypes from 'prop-types';
//material-ui design helpers



import { LoadingDialog } from '../dialogs';
import {corestyles} from '../../styles';
import { createItemList } from '../form';
import { formatJsonDataset, formatJsonLocation } from '../renderers';
import { Box } from '@mui/material';

const s:any = {
  ...corestyles,
}

/**
 * -------------------------------------------------------------------
 * Service Panel
 * -------------------------------------------------------------------
 */
class SimplePanel extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      mode: this.props.mode,
      init: false,
      loading: false,
      fopen: false,
      childs: {}
    };
  }

  startLoading = () => {
    this.setState({ loading: true });
  }

  stopLoading = () => {
    this.setState({ loading: false });
  }

  // setChildren = (items) => {
  //   const childs = {};
  //   items.map(item=>{
  //     childs[item.id]=item.dom;
  //     return true;
  //   });
  //   this.setState({childs});
  // }

  // resetChildren = (childs) => {
  //   //
  // }

  render = () => {
    //console.log('in simple.render');
    const { mode, sdata, record, formatters, onChange, classes, selected, reset, cvalue, cuparams,...others } = this.props;
    const { loading } = this.state;
    //const extra = {selected, reset, cvalue, resetChildren:this.resetChildren, ...others}; 

    //const options = {};
    const extras = {selected, reset, cvalue, cuparams, others };
    
    //const extra = 
    const formitems = createItemList(mode, sdata, record, formatters, onChange, extras);
    console.log('simple.items',formitems);
    return (
      <Box sx={{...s.container}}>
        <Box component='form' id="requestform" sx={{...s.reqform}}>
          {//loading &&
            <LoadingDialog status={loading} start={this.startLoading} stop={this.stopLoading} />
          }
          {formitems.map((item:any) => (
            <Box key={item.id}>
              {item.id === 'exi' ||item.id === 'req' || item.id === 'res' ? 
                <Box>
                  <Box component='span'>{item.dom.props.label} {formatJsonDataset(item.dom.props.value,record)}</Box>
                </Box> 
              : item.id === 'geo' ? 
                <Box component='span'>{item.dom.props.label} {formatJsonLocation(item.dom.props.value,record)}</Box>
              :item.dom
              }
            </Box>
          ))}
        </Box>
      </Box>
    );
  }
};

SimplePanel.propTypes = {
  service: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(['add', 'edit', 'delete', 'view', 'close', 'manage', 'wizard']).isRequired,
  sdata: PropTypes.object,
  record: PropTypes.object,
  onChange: PropTypes.func,
  formatters: PropTypes.object,
};

//SimplePanel = withStyl...corestyles, { withTheme: true })(SimplePanel);

export default SimplePanel;
